import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  connections: [],
  featureStatuses: [],
  areFeatureStatusesLoaded: false,
  collectionsSettings: null,
  isLoading: false,
  isTesting: {},
  error: null,
  featureStatusesError: null,
};

const upsertConnection = (state, connection) => {
  if (!connection) {
    return;
  }
  const index = state.connections.findIndex(
    (candidate) => candidate.id === connection.id
  );
  if (index >= 0) {
    state.connections[index] = connection;
  } else {
    state.connections.push(connection);
  }
};

const upsertFeatureStatus = (state, status) => {
  if (!status) {
    return;
  }
  const index = state.featureStatuses.findIndex(
    (candidate) => candidate.feature === status.feature
  );
  if (index >= 0) {
    state.featureStatuses[index] = status;
  } else {
    state.featureStatuses.push(status);
  }
};

export const llmConfigSlice = createSlice({
  name: "llmConfig",
  initialState: INITIAL_STATE,
  reducers: {
    setLlmConnections: (state, { payload }) => {
      state.connections = payload || [];
    },
    setLlmConnection: (state, { payload }) => {
      upsertConnection(state, payload);
    },
    removeLlmConnection: (state, { payload: id }) => {
      state.connections = state.connections.filter(
        (connection) => connection.id !== id
      );
    },
    setLlmFeatureStatuses: (state, { payload }) => {
      state.featureStatuses = payload || [];
      state.areFeatureStatusesLoaded = true;
      state.featureStatusesError = null;
    },
    setLlmFeatureStatusesError: (state, { payload }) => {
      state.featureStatusesError = payload;
    },
    setLlmFeatureStatus: (state, { payload }) => {
      upsertFeatureStatus(state, payload);
    },
    setCollectionsSettings: (state, { payload }) => {
      state.collectionsSettings = payload || null;
    },
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setIsTestingConnection: (state, { payload: { id, isTesting } }) => {
      state.isTesting = { ...state.isTesting, [id]: isTesting };
    },
    setLlmConfigError: (state, { payload }) => {
      state.error = payload;
    },
  },
});

export const {
  setLlmConnections,
  setLlmConnection,
  removeLlmConnection,
  setLlmFeatureStatuses,
  setLlmFeatureStatusesError,
  setLlmFeatureStatus,
  setCollectionsSettings,
  setIsLoading,
  setIsTestingConnection,
  setLlmConfigError,
} = llmConfigSlice.actions;

export default llmConfigSlice.reducer;
